import { useMemo } from 'react';

import { STEPS } from 'components/modules/Insurance/Insurance.constants';
import { Insurance } from 'constants/routes';
import { useRouteMatch } from 'hooks/useRouteMatch';

const { ROUTES } = Insurance;

export const useStepperPresenter = () => {
  const { route } = useRouteMatch({ routes: ROUTES }) ?? {};

  const steps = useMemo(() => {
    return STEPS.map(({ routes, ...rest }) => {
      const active = routes.has(route);

      return { ...rest, active };
    });
  }, [route]);

  return { steps };
};
